import React, {FC} from "react"
import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import {Body, H2} from "@irati/ui/src/Typography"
import GenericModal from "@irati/ui/src/GenericModal"
import FormattedMessage from "@irati/utils/lang"
import {Icon} from "./styled"

interface Props {
  isShown: boolean
  onHide: () => void
  onComplete: () => void
}

const ConfirmationModal: FC<Props> = ({isShown, onHide, onComplete}) => {
  return (
    <GenericModal show={isShown} onHide={onHide} className="modal-slide-up" hideActions>
      <Flex direction="column" gap={4} alignItems="center">
        <div />
        <Icon />
        <H2>
          <FormattedMessage id="wallet.reward.admin.subscriptionBanner.modalConfirm.title" />
        </H2>
        <Body textAlign="center">
          <FormattedMessage id="wallet.reward.admin.subscriptionBanner.modalConfirm.info" />
        </Body>
        <Button
          primary
          full
          onClick={onComplete}>
          <FormattedMessage id="wallet.reward.admin.subscriptionBanner.modalConfirm.cta" />
        </Button>
      </Flex>
    </GenericModal>
  )
}

export default ConfirmationModal
